import { SolarPower } from '@mui/icons-material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getMonthString } from '../../../../modules/consumptionDataParser'
import { SolarPanelHook } from '../../../devices/solarPanel/hooks/useSolarPanel'

interface Props {
	month: number
	inverter: SolarPanelHook
}

const ProductionCircle: React.FC<Props> = ({ month, inverter }) => {
	const { t } = useTranslation('pages_overview')

	const value = !inverter.isLoading ? inverter.savings : 0

	return (
		<div className='slide-container'>
			<div id='circle' className='bg-white dark:bg-background-200-dark'>
				<div
					id='inner'
					className='bg-white dark:bg-background-200-dark text-text-dark dark:text-text-light'
				>
					<div className='icons-container'>
						<SolarPower
							sx={{ fontSize: '1.6rem' }}
							className='text-brand-primary-100-light dark:text-brand-primary-100-dark'
						/>
					</div>
					<span className='current-month-title'>{getMonthString(month)}</span>
					<span className='main-value'>
						{Math.floor(value).toFixed(0)}
						<span className='cents'>,{value.toFixed(2).split('.')[1]}</span>
						<span className='unit text-text-grey-300 dark:text-text-grey-100'>€</span>
					</span>
					<div className='bottom'>{t('circles.paneelit')}</div>
				</div>
			</div>
		</div>
	)
}

export default ProductionCircle
